var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"text-h6",staticStyle:{"font-weight":"300"}},_vm._l((_vm.parsedText),function(item,index){return _c('span',{key:index,class:{ bold: item.isBold }},[_vm._v(" "+_vm._s(item.text)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }